<div class="center-align">
  <div class="search-panel">
    <mat-label class="d-inline-block">
      <p class="searchlist-header">Search Generator / Fuel Tank / Trailers</p>
    </mat-label>
  </div>
  <div>
    <mat-form-field appearance="outline" class="mat-form-field-infix-class search-box">
      <mat-label for="assetIdInput">Asset Id</mat-label>
      <input
        #assetIdInput
        matInput
        id="assetIdInput"
        placeholder="QR Code Asset ID / Local ID / Reference ID"
        [formControl]="vm?.assetIDSearchTerm"
        [matAutocomplete]="AssetIDAuto">
      <mat-autocomplete #AssetIDAuto="matAutocomplete" [displayWith]="getAssetId" (optionSelected)="searchByAssetId($event)">
        <mat-option *ngFor="let asset of vm?.generatorAssetSearchResult; trackBy: trackByAsset" [value]="asset">
          <span>
            <span *ngIf="asset.assetId"><span class="text-type-bold">QR Code - </span>{{ asset.assetId }} | </span>
            <span *ngIf="asset.localId"><span class="text-type-bold">Local ID - </span>{{ asset.localId }} | </span>
            <span *ngIf="asset.fuelTankId"><span class="text-type-bold">Ref ID - </span>{{ asset.fuelTankId }}</span>
            <span *ngIf="asset.generatorId"><span class="text-type-bold">Ref ID - </span>{{ asset.generatorId }}</span>
            <span *ngIf="asset.trailerId"><span class="text-type-bold">Ref ID - </span>{{ asset.trailerId }}</span>
          </span>
        </mat-option>
      </mat-autocomplete>
      <button
        class="search-button"
        mat-mini-fab
        matSuffix
        type="button"
        [attr.aria-label]="vm?.scannerEnabled ? 'Close scanner' : 'Open scanner'"
        (click)="enableScanner()">
        <mat-icon>qr_code_scanner</mat-icon>
      </button>
    </mat-form-field>

    <div *ngIf="vm?.scannerEnabled" class="scanner-container">
      <zxing-scanner
        #scanner
        id="qr-reader"
        (scanSuccess)="scanSuccessHandler($event)">
      </zxing-scanner>
      <div #focusFrame *ngIf="vm?.zoomFlag" class="focus-frame"></div>
      <div *ngIf="vm?.zoomFlag" class="zoom-controls">
        <button aria-label="Zoom in" class="zoom-icon" type="button" (click)="zoomIn()">
          <span aria-hidden="true" class="fa fa-search-plus"></span>
        </button>
        <button aria-label="Zoom out" class="zoom-icon" type="button" (click)="zoomOut()">
          <span aria-hidden="true" class="fa fa-search-minus"></span>
        </button>
      </div>
    </div>

    <mat-form-field appearance="outline" class="mat-form-field-infix-class search-box">
      <mat-label for="nwtTeamInput">NWT Team</mat-label>
      <input
        matInput
        id="nwtTeamInput"
        placeholder="NWT Team"
        [formControl]="vm?.nwtTeamSearchTerm"
        [matAutocomplete]="NwTTeamAuto">
      <mat-autocomplete #NwTTeamAuto="matAutocomplete" [displayWith]="getNwtTeam" (optionSelected)="searchByNwTTeam($event)">
        <mat-option *ngFor="let nwtTeam of vm?.generatorNwtTeamSearchResult; trackBy: trackByNwtTeam" [value]="nwtTeam">
          <span>{{ nwtTeam }}</span>
        </mat-option>
      </mat-autocomplete>
      <button class="search-button" mat-mini-fab matSuffix>
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" class="mat-form-field-infix-class search-box">
      <mat-label for="nodeSearchInput">Node</mat-label>
      <input
        #node
        matInput
        id="nodeSearchInput"
        placeholder="Enter Node"
        [formControl]="vm?.nodeSearchTerm"
        [matAutocomplete]="auto"
        (keydown)="onChangeSearchNodes($event)"
        (keyup)="onChangeSearchNodes($event)"
      >
      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="getNodeName"
        (optionSelected)="nodeSelected($event)">
        <mat-option *ngFor="let item of vm?.searchResult; trackBy: trackByNode" [value]="item">
          <span>{{ item.node }} / {{ item.nodeCmts }}</span>
        </mat-option>
      </mat-autocomplete>
      <button
        class="search-button"
        mat-mini-fab
        matSuffix
        [disabled]="vm?.searchNodeFlag"
        (click)="onChangeSearchPSNav()">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" class="mat-form-field-infix-class search-box">
      <mat-label for="makeSearchInput">Make</mat-label>
      <input
        matInput
        id="makeSearchInput"
        placeholder="Make"
        [formControl]="vm?.makeSearchTerm"
        [matAutocomplete]="MakeAuto">
      <mat-autocomplete #MakeAuto="matAutocomplete" [displayWith]="getMake" (optionSelected)="searchByMake($event)">
        <mat-option *ngFor="let make of vm?.generatorMakeSearchResult; trackBy: trackByMake" [value]="make">
          <span>{{ make }}</span>
        </mat-option>
      </mat-autocomplete>
      <button class="search-button" mat-mini-fab matSuffix>
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" class="mat-form-field-infix-class search-box">
      <mat-label for="modelSearchInput">Model</mat-label>
      <input
        matInput
        id="modelSearchInput"
        placeholder="Model"
        [formControl]="vm?.modelSearchTerm"
        [matAutocomplete]="ModelAuto">
      <mat-autocomplete #ModelAuto="matAutocomplete" [displayWith]="getModel" (optionSelected)="searchByModel($event)">
        <mat-option *ngFor="let model of vm?.generatorModelSearchResult; trackBy: trackByModel" [value]="model">
          <span>{{ model }}</span>
        </mat-option>
      </mat-autocomplete>
      <button class="search-button" mat-mini-fab  matSuffix>
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>
  </div>
  <div class="bottom-button-group">
    <button class="button generator-create-button" mat-button (click)="openCreateAssetDialog()">
      <span aria-hidden="true" class="fa fa-plus navicon"></span>
      Create Asset
    </button>
    <hr class="horizontal-line">
    <button class="button generator-search-button" mat-button routerLink="/">
      <span aria-hidden="true" class="fa fa-search navicon"></span>
      Search Power Supply
    </button>
  </div>
</div>